export default __webpack_public_path__ + "static/media/loan_n.76a34ef4.svg";